import React from 'react'
import GalleryComponent from '../components/Gallery'
const BannerLanding = (props) => (
  <section id="banner" className="style2">
    <div className="inner">
      <header className="major">
        <h1>{props.title}</h1>
      </header>
      <div className="content">
        <p>{props.descript}</p>
        <GalleryComponent />
      </div>
    </div>
  </section>
)

export default BannerLanding
